var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 33.18",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "claimreview"
  }, "Claim In Review") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "claimreview"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "M30.77,30.69a.53.53,0,1,1,.53-.53A.54.54,0,0,1,30.77,30.69Zm0-.85a.32.32,0,0,0-.32.32.32.32,0,1,0,.63,0A.31.31,0,0,0,30.77,29.84Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "illustrationsAccent1",
    cx: 15.02,
    cy: 17.39,
    r: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M21.89,15h1.64a.33.33,0,0,0,0-.65H21.89a2.08,2.08,0,0,1-2.07-2.08V10.59a.32.32,0,0,0-.33-.32.32.32,0,0,0-.32.32v1.63A2.73,2.73,0,0,0,21.89,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "M21.19,22.39h-6.6a.86.86,0,1,1,0-1.7h6.6a.86.86,0,1,1,0,1.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M12.93,1.72a.2.2,0,0,0-.2.2v.47a.2.2,0,0,0,.4,0V1.92a.2.2,0,0,0-.2-.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M12.4,1.24h-.47a.21.21,0,0,0-.21.21.2.2,0,0,0,.21.2h.47a.2.2,0,0,0,.2-.2.2.2,0,0,0-.2-.21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M12.93.27a.2.2,0,0,0-.2.2V.94a.2.2,0,1,0,.4,0V.47a.2.2,0,0,0-.2-.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M13.93,1.21h-.47a.2.2,0,0,0-.2.2.2.2,0,0,0,.2.21h.47a.21.21,0,0,0,.21-.21.2.2,0,0,0-.21-.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M33.32,23.88a.34.34,0,0,0-.32.35V25a.33.33,0,0,0,.32.34.33.33,0,0,0,.32-.34v-.8a.34.34,0,0,0-.32-.35",
    "data-name": "Fill-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M32.44,23h-.8a.32.32,0,1,0,0,.64h.8a.32.32,0,1,0,0-.64",
    "data-name": "Fill-7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M33.32,21.33a.33.33,0,0,0-.32.34v.8a.34.34,0,0,0,.32.35.34.34,0,0,0,.32-.35v-.8a.33.33,0,0,0-.32-.34",
    "data-name": "Fill-8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M35,23h-.8a.32.32,0,1,0,0,.64H35A.32.32,0,1,0,35,23",
    "data-name": "Fill-9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M2.11,16S2.4,18,0,18c0,0,2,0,2,1.89A2.28,2.28,0,0,1,4.06,18s-1.58.36-1.95-2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent2",
    d: "M30.83,2.39s.29,2-2.09,1.95c0,0,2,0,2,1.88a2.27,2.27,0,0,1,2.06-1.79s-1.59.35-2-2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent2",
    d: "M5.38,27.5a1,1,0,0,1-1.1,1.08,1,1,0,0,1,1,1.05,1.24,1.24,0,0,1,1.08-1s-.83.2-1-1.13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M5.36,8.14a.57.57,0,0,1-.66.65s.65,0,.63.62A.74.74,0,0,1,6,8.82s-.5.11-.62-.68"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "M23.43,1.54a.64.64,0,1,1,0-1.27.63.63,0,0,1,.63.63A.63.63,0,0,1,23.43,1.54Zm0-1.06a.43.43,0,1,0,.42.42A.42.42,0,0,0,23.43.48Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "M2.47,4.31A.54.54,0,1,1,3,3.78.53.53,0,0,1,2.47,4.31Zm0-.85a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32.33.33,0,0,0,.32-.32A.32.32,0,0,0,2.47,3.46Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M35.45,14.1a.54.54,0,1,1,.53-.54A.54.54,0,0,1,35.45,14.1Zm0-.86a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32.32.32,0,0,0,.32-.32A.33.33,0,0,0,35.45,13.24Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "M15.68,9H12.47a1.81,1.81,0,0,0-1.81,1.81v17a1.81,1.81,0,0,0,1.81,1.81h2.42a4,4,0,0,1-2-3.55V13.27A4.69,4.69,0,0,1,15.68,9Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M20,29.63H12.47a1.81,1.81,0,0,1-1.81-1.81v-17A1.81,1.81,0,0,1,12.47,9H23.32a1.81,1.81,0,0,1,1.81,1.81V25.16a3.55,3.55,0,0,1,1.06.86V10.8a2.87,2.87,0,0,0-2.87-2.87H12.47A2.86,2.86,0,0,0,9.6,10.8v17a2.87,2.87,0,0,0,2.87,2.87h8.2A3.55,3.55,0,0,1,20,29.63Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M22,27.09a1.61,1.61,0,0,0-.47,1.32.24.24,0,0,0,.24.22h0a.24.24,0,0,0,.22-.26,1.11,1.11,0,0,1,.33-.94.24.24,0,1,0-.34-.34Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "M27.26,31.89l-1.65-1.66a2.94,2.94,0,0,0,.68-1.87,2.87,2.87,0,1,0-2.87,2.88,2.81,2.81,0,0,0,1.66-.53l1.67,1.68a.36.36,0,0,0,.26.11.36.36,0,0,0,.25-.11A.35.35,0,0,0,27.26,31.89Zm-3.84-1.34a2.19,2.19,0,1,1,2.18-2.19A2.18,2.18,0,0,1,23.42,30.55Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "M22.08,25a.81.81,0,0,0,.06-.31.9.9,0,0,0-.95-.85h-6.6a.86.86,0,1,0,0,1.7h6.56A3.59,3.59,0,0,1,22.08,25Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.d668bce1cfb7e756e337d3a2a11f4b8b.svg";
export { ForwardRef as ReactComponent };